import { render, staticRenderFns } from "./AnswersSummary.vue?vue&type=template&id=116915cc&"
import script from "./AnswersSummary.vue?vue&type=script&lang=js&"
export * from "./AnswersSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports